var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.49992V4.76659C14.6667 3.73982 14.6667 3.22644 14.4668 2.83427C14.2911 2.48931 14.0106 2.20884 13.6656 2.03307C13.2735 1.83325 12.7601 1.83325 11.7333 1.83325H10.2667C9.2399 1.83325 8.72652 1.83325 8.33435 2.03307C7.98939 2.20884 7.70892 2.48931 7.53315 2.83427C7.33333 3.22644 7.33333 3.73982 7.33333 4.76659V5.49992M9.16667 10.5416V15.1249M12.8333 10.5416V15.1249M2.75 5.49992H19.25M17.4167 5.49992V15.7666C17.4167 17.3067 17.4167 18.0768 17.1169 18.6651C16.8533 19.1825 16.4326 19.6032 15.9151 19.8669C15.3269 20.1666 14.5568 20.1666 13.0167 20.1666H8.98333C7.44319 20.1666 6.67312 20.1666 6.08486 19.8669C5.56741 19.6032 5.14672 19.1825 4.88307 18.6651C4.58333 18.0768 4.58333 17.3067 4.58333 15.7666V5.49992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash01);
export default __webpack_public_path__ + "static/media/trash-01.9ac5f457b8de45f69e8eab9cd2bf5b0f.svg";
export { ForwardRef as ReactComponent };